import { ref } from 'vue'

export function usePercentageMode(initialValue = false) {
  const isPercentageMode = ref(initialValue)

  const togglePercentageMode = () => {
    isPercentageMode.value = !isPercentageMode.value
  }

  return {
    isPercentageMode,
    togglePercentageMode,
  }
}
